export default __webpack_public_path__ + "static/media/setting.c68d2c10.svg";